export default "__VITE_ASSET__Cwd24BAP__"